module.exports = __webpack_public_path__ + "img/1_no.20c5ceea.svg";